import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/LandingPage.css"; // Archivo de estilos personalizados
import logo from "../assets/logo1.png"; // Imagen del logo
import background from "../assets/ipn3.jpeg"; // Imagen de fondo
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from '../components/Navbar';
import { PLATFORM_NAME, PLATFORM_LEGAL_MESSAGE } from '../constants/platform';

const LandingPage = () => {
  useEffect(() => {
    // Asegurarse de que Bootstrap está inicializado correctamente
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />

      {/* Aviso legal al inicio */}
      <section className="platform-legal-banner py-2 px-3">
        <div className="container">
          <p className="mb-1 fw-bold text-dark small">{PLATFORM_NAME}</p>
          {PLATFORM_LEGAL_MESSAGE.paragraphs.map((text, i) => (
            <p key={i} className="mb-0 small text-muted">{text}</p>
          ))}
        </div>
      </section>

      {/* Hero Section */}
      <header className="hero-section" style={{ backgroundImage: `url(${background})` }}>
        <div className="container text-center text-white purpose-box">
          <h1 className="display-4">MIRAI ABILITY LAB®</h1>
          <p className="lead">Plataforma Inteligente de Evaluación y Diagnóstico del Talento Estudiantil. Diseñada para ayudarte a conocerte mejor y contribuir al mejoramiento de tu comunidad educativa a través de evaluaciones especializadas que permiten a las autoridades educativas implementar acciones en beneficio de todos.</p>
        </div>
      </header>

      {/* Sección de Evaluaciones Disponibles */}
      <section className="container my-5">
        <h2 className="text-center mb-4">📊 INSTRUMENTOS DE EVALUACIÓN</h2>
        <div className="row">
          <div className="col-md-6 col-lg-6 mb-4">
            <div className="card h-100">
              <div className="card-body text-center">
                <i className="bi bi-people-fill icon-feature mb-3"></i>
                <h5 className="card-title">HABILIDADES BLANDAS</h5>
                <p className="card-text">Evalúa comunicación, liderazgo, trabajo en equipo e inteligencia emocional</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 mb-4">
            <div className="card h-100">
              <div className="card-body text-center">
                <i className="bi bi-lightbulb-fill icon-feature mb-3"></i>
                <h5 className="card-title">INTELIGENCIAS MÚLTIPLES</h5>
                <p className="card-text">Identifica tus diferentes tipos de inteligencia según Howard Gardner</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 mb-4">
            <div className="card h-100">
              <div className="card-body text-center">
                <i className="bi bi-mortarboard icon-feature mb-3"></i>
                <h5 className="card-title">ORIENTACIÓN VOCACIONAL</h5>
                <p className="card-text">Explora tus intereses y aptitudes para nivel medio superior y superior</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 mb-4">
            <div className="card h-100">
              <div className="card-body text-center">
                <i className="bi bi-shield-check icon-feature mb-3"></i>
                <h5 className="card-title">DETECCIÓN DE VIOLENCIA DE GÉNERO</h5>
                <p className="card-text">Identifica situaciones de riesgo para crear entornos seguros</p>
              </div>
            </div>
          </div>
        </div>
        <p className="text-center text-muted mt-3">Los cuestionarios disponibles pueden incrementarse de acuerdo a las necesidades específicas de cada institución educativa.</p>
      </section>

      {/* Sección de Beneficios */}
      <section className="container my-5">
        <h2 className="text-center mb-4">¿CÓMO TE BENEFICIA?</h2>
        <div className="row text-center">
          <div className="col-md-4 mb-4">
            <i className="bi bi-search icon-feature"></i>
            <h4>Autoconocimiento</h4>
            <p>Descubre tus fortalezas y áreas de mejora</p>
          </div>
          <div className="col-md-4 mb-4">
            <i className="bi bi-lightbulb icon-feature"></i>
            <h4>Orientación personalizada</h4>
            <p>Recibe recomendaciones específicas para tu desarrollo</p>
          </div>
          <div className="col-md-4 mb-4">
            <i className="bi bi-heart icon-feature"></i>
            <h4>Entorno mejorado</h4>
            <p>Contribuyes a crear una comunidad educativa más segura e inclusiva</p>
          </div>
        </div>
      </section>

      {/* Sección de Uso de Información */}
      <section className="container my-5">
        <h2 className="text-center mb-4">📈 PARA LAS AUTORIDADES EDUCATIVAS</h2>
        <p className="text-center mb-4">Los resultados permiten implementar:</p>
        <div className="row">
          <div className="col-md-6">
            <ul className="list-group list-group-flush">
              <li className="list-group-item"><i className="bi bi-check-circle text-success me-2"></i>Programas de prevención y apoyo</li>
              <li className="list-group-item"><i className="bi bi-check-circle text-success me-2"></i>Estrategias educativas personalizadas</li>
              <li className="list-group-item"><i className="bi bi-check-circle text-success me-2"></i>Protocolos de seguridad y bienestar</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul className="list-group list-group-flush">
              <li className="list-group-item"><i className="bi bi-check-circle text-success me-2"></i>Capacitación docente especializada</li>
              <li className="list-group-item"><i className="bi bi-check-circle text-success me-2"></i>Mejoras en infraestructura de apoyo</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Sección de Confidencialidad */}
      <section className="container my-5">
        <h2 className="text-center mb-4">🔒 TU INFORMACIÓN ESTÁ PROTEGIDA</h2>
        <div className="row">
          <div className="col-md-6">
            <ul className="list-group list-group-flush">
              <li className="list-group-item"><i className="bi bi-shield-lock text-primary me-2"></i>Confidencialidad absoluta de todos tus datos</li>
              <li className="list-group-item"><i className="bi bi-shield-lock text-primary me-2"></i>Uso exclusivamente educativo de la información</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul className="list-group list-group-flush">
              <li className="list-group-item"><i className="bi bi-shield-lock text-primary me-2"></i>Procesamiento anónimo para análisis institucionales</li>
              <li className="list-group-item"><i className="bi bi-shield-lock text-primary me-2"></i>Acceso restringido solo a personal autorizado</li>
            </ul>
          </div>
        </div>
        <div className="alert alert-info mt-4">
          <h5>📋 AVISO DE PRIVACIDAD</h5>
          <p className="mb-0">Esta plataforma cuenta con un Aviso de Privacidad completo que detalla el manejo de tus datos, tus derechos y las medidas de seguridad implementadas. Consúltalo antes de iniciar.</p>
        </div>
      </section>

      {/* Sección de Tiempo de Evaluación */}
      <section className="container my-5">
        <h2 className="text-center mb-4">⏱️ DURACIÓN ESTIMADA</h2>
        <div className="row text-center">
          <div className="col-md-3 mb-3">
            <div className="card">
              <div className="card-body">
                <h6>Habilidades Blandas</h6>
                <p className="text-muted">30 minutos</p>
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card">
              <div className="card-body">
                <h6>Inteligencias Múltiples</h6>
                <p className="text-muted">10-15 minutos</p>
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card">
              <div className="card-body">
                <h6>Orientación Vocacional</h6>
                <p className="text-muted">10-15 minutos</p>
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card">
              <div className="card-body">
                <h6>Violencia de Género</h6>
                <p className="text-muted">10-15 minutos</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Proceso */}
      <section className="container my-5">
        <h2 className="text-center mb-4">PROCESO SIMPLE</h2>
        <div className="row">
          <div className="col-md-8 mx-auto">
            <div className="list-group">
              <div className="list-group-item d-flex align-items-center">
                <span className="badge bg-primary rounded-pill me-3">1</span>
                <span>Regístrate con información básica</span>
              </div>
              <div className="list-group-item d-flex align-items-center">
                <span className="badge bg-primary rounded-pill me-3">2</span>
                <span>Acepta términos y aviso de privacidad</span>
              </div>
              <div className="list-group-item d-flex align-items-center">
                <span className="badge bg-primary rounded-pill me-3">3</span>
                <span>Selecciona las evaluaciones que deseas completar</span>
              </div>
              <div className="list-group-item d-flex align-items-center">
                <span className="badge bg-primary rounded-pill me-3">4</span>
                <span>Responde honestamente todas las preguntas</span>
              </div>
              <div className="list-group-item d-flex align-items-center">
                <span className="badge bg-primary rounded-pill me-3">5</span>
                <span>Recibe tus resultados personalizados</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mensaje Final */}
      <section className="container my-5">
        <div className="final-message-container">
          <div className="final-message-content">
            <div className="final-message-icon">
              <i className="bi bi-heart-fill"></i>
            </div>
            <h2 className="final-message-title">MENSAJE FINAL</h2>
            <div className="final-message-text">
              <p className="final-message-paragraph">
                Esta plataforma existe para apoyarte en tu crecimiento personal y académico, mientras contribuyes a crear una comunidad educativa más fuerte y segura.
              </p>
              <p className="final-message-paragraph">
                Tu participación es valiosa y confidencial. Los resultados te ayudarán a conocerte mejor, mientras que la información permitirá implementar acciones que beneficien a toda la comunidad educativa.
              </p>
            </div>
            <div className="final-message-decoration">
              <div className="decoration-line"></div>
              <i className="bi bi-star-fill decoration-star"></i>
              <div className="decoration-line"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de CTA */}
      <div className="text-center my-5">
        <Link to="/register" className="btn btn-custom" style={{maxWidth: '320px', width: '100%', display: 'inline-block'}}>
          Regístrate Ahora
        </Link>
      </div>
    </>
  );
};

export default LandingPage;
